import * as types from '../actions/types';

export const initialState = {
  assetsLoaded: 0,
  currentVideoLoaded: true,
  appReady: false,
  videoWaiting: false,
  imageSequencePlaying: false,
  loadedVideos: {},
};

export default function (prevState = initialState, action) {
  switch (action.type) {
    case types.GO_TO_GROUP:
      return Object.assign({}, prevState, {
        assetsLoaded: 0,
        currentVideoLoaded: false,
        appReady: true,
        videoWaiting: false,
        imageSequencePlaying: false,
      });
    case types.GO_TO_STAGE:
      return Object.assign({}, prevState, {
        assetsLoaded: 0,
        currentVideoLoaded: false,
        videoWaiting: false,
        imageSequencePlaying: false,
      });
    case types.SET_NEXT_VIDEO_LOADED:
      if (prevState.assetsLoaded === 3) {
        return Object.assign({}, prevState, {
          assetsLoaded: prevState.assetsLoaded + 1,
          appReady: true,
        });
      } else {
        return Object.assign({}, prevState, {
          assetsLoaded: prevState.assetsLoaded + 1,
        });
      }
    case types.SET_CURRENT_VIDEO_LOADED:
      return Object.assign({}, prevState, {
        currentVideoLoaded: true,
      });
    case types.SET_VIDEO_WAITING:
      return Object.assign({}, prevState, {
        videoWaiting: true,
      });
    case types.SET_VIDEO_LOADED:
      const loadedVideos = prevState.loadedVideos;
      loadedVideos[action.name] = true;

      return Object.assign({}, prevState, {
        loadedVideos: loadedVideos,
      });
    case types.UNSET_VIDEO_WAITING:
      return Object.assign({}, prevState, {
        videoWaiting: false,
      });
    case types.GO_BACK:
      return Object.assign({}, prevState, {
        assetsLoaded: 0,
      });
    case types.PLAY_IMAGE_SEQUENCE:
      return Object.assign({}, prevState, {
        imageSequencePlaying: true,
      });
    default:
      return prevState;
  }
}
